<template>
  <div class="article-faq-wrapper">
    <h3 class="article-faq__block-title">
      FAQ
    </h3>

    <div
      v-for="(item, index) in faqItems"
      :key="index"
      :class="['article-faq', { 'is-active': item.isOpen }]"
      @click="toggleFaq(index)">
      <div class="article-faq__title">
        <div class="article-faq__trigger">
          <p class="article-faq__summary">
            {{ item.question }}
          </p>
          <div class="article-faq__plus" />
        </div>
      </div>

      <transition
        name="accordion-item"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition">
        <div
          v-if="item.isOpen"
          class="article-faq__details">
          <p class="article-faq__text">
            {{ item.answer }}
          </p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqComponent',
  props: {
    faqs: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      faqItems: this.faqs.map((faq) => ({ ...faq, isOpen: false })),
    };
  },

  methods: {
    toggleFaq(index) {
      this.faqItems[index].isOpen = !this.faqItems[index].isOpen;
    },

    startTransition(el) {
      el.style.height = `${el.scrollHeight}px`;
    },

    endTransition(el) {
      el.style.height = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.article-faq-wrapper {
  display: grid;
  grid-auto-flow: row;
  grid-row-gap: 8px;
}

.article-faq {
  background-color: $color--basic-menu;
  border-radius: 4px;
  padding: 19px 16px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.article-faq__block-title {
  font-size: 25px;
  font-weight: 500;
  margin-bottom: 24px;
}

.article-faq__trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
  padding: 0;
}

.article-faq__summary {
  font-size: 15px;
  font-weight: 500;
  background-color: transparent;
  pointer-events: none;
  margin-bottom: 0;
}

.article-faq__details {
  overflow: hidden;
  transition: height 0.3s ease-out;
}

.accordion-item-enter-active, .accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}

.accordion-item-enter, .accordion-item-leave-to {
  height: 0 !important;
}

.article-faq__title {
  position: relative;
  font-size: 25px;
  font-weight: 500;
}

.article-faq__text {
  font-size: 15px;
  color: $color--basic-light-gray;
  margin-top: 12px;
}

.article-faq__plus {
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
}

.article-faq__plus::before,
.article-faq__plus::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  height: 3px;
  border-radius: 100px;
  background-color: $color--basic-light-gray;
  display: block;
}

.article-faq__plus::before {
  transform: translate(-50%, -50%);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
}

.article-faq__plus::after {
  transform: translate(-50%, -50%) rotate(90deg);
  transition: transform 0.3s ease-out;
}

.is-active .article-faq__plus::before {
  opacity: 0;
  transform: translate(-50%, -50%) rotate(180deg);
}

.is-active .article-faq__plus::after {
  transform: translate(-50%, -50%);
}
</style>
